import PHCreate from './ph-create.endpoint.api';

const client = {
    api: {
        PHCreate,
    },
};

export default client;
